import React from 'react'

const Footer = () => {

    return (
        <>
            <footer className="page-footer font-small indigo">
                <div className="footer-copyright text-center py-3">© 2020 Copyright:
                    <a href="emailto: behzadbabaei@gmail.com"> behzadbabaei@gmail.com </a>
                </div>
            </footer>

        </>
    );
}

export default Footer;